import React from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardFooter,
  Button,
  Form,
  FormGroup,
  Alert,
  Container,
  Label,
  Input,
} from "reactstrap";
import PageTitle from "../../../components/common/PageTitle";
import {
  SelectAllFeatureList,
  saveFeature,
  SelectByID,
} from "../../../api/Feature";
import Select from "react-select";
import {
  AddRoleForAdmin,
  UpdateMenuGroup,
  SelectByGroup,
} from "../../../api/Feature";
import { connect } from "react-redux";
import FeatureList from "./FeatureList";

class FeatureEntry extends React.Component {
  static routeName = "/setup/feature-entry";

  constructor(props) {
    super(props);
    this.state = {
      formState: "new",
      data: [],

      isLoading: false,

      errors: [],
      successMessage: "",
      messageVisible: false,

      rowKey: "",

      FeatureID: "",
      MenuCode: "",
      MenuName: "",
      MenuType: "MG",
      MenuGroupCode: "",
      ModuleCode: "",
      PageURL: "",
      DefaultExpanse: "0",
      ExtendedPerm: "",

      group: [],
      selectedGroup: null,

      CreateSubMenuMode: false,
      SelectMainMenuName: "",
      SelectMainMenuGroup: "",

      SubMenu: false,
      SelectedPageFeature: [],

      selectFeatureGroupName: "",
      SelectedSubMenu: [],
      CreatedBy: this.props.auth.displayName,
      id: this.props.match.params.id,
    };
  }

  async componentDidMount() {
    await this.loadData();
    if (this.state.id) {
      const featureId = this.state.id;
      //call select item
      const res = await SelectByID(featureId);
      let group = this.state.group;
      let selectedGroup;
      //if user selected item haved , it display selected item's group
      group.forEach((value) => {
        if (res.menuGroupCode == value.value) return (selectedGroup = value);
      });

      //Use to delete the main menu and related menus
      const response = await SelectByGroup(
        this.props.location.state.menuGroupCode
      );
      let selectedmenus = [];
      response.records.forEach((row) => {
        selectedmenus.push(row.featureId);
      });

      if (res) {
        this.setState({
          isLoading: false,
          formState: "edit",
          rowKey: featureId,
          MenuCode: res.menuCode,
          MenuName: res.menuName,
          MenuType: res.menuType,
          FeatureID: featureId,
          MenuGroupCode: res.menuGroupCode,
          ModuleCode: res.moduleCode,
          PageURL: res.pageURL,
          DefaultExpanse: res.defaultExpanse ? 1 : 0,
          ExtendedPerm: res.extendedPerm,
          selectedGroup: selectedGroup,
          SelectMainMenuName: res.menuName,
          SelectMainMenuGroup: res.menuGroupCode,
          SelectedSubMenu: selectedmenus,
        });
      }
    }
  }

  async loadData() {
    this.setState({ isLoading: true });
    //call all data for group
    let ItemList = await SelectAllFeatureList();
    let group = [];
    //set data list to display menu dropdown
    ItemList.forEach((obj) => {
      if (obj.menuType === "MG") {
        group.push({ label: obj.menuName, value: obj.menuGroupCode });
      }
    });
    this.setState({ group, isLoading: false });
  }

  CreateME() {
    this.setState({
      CreateSubMenuMode: true,
      rowKey: "",
      MenuCode: "",
      MenuName: "",
      MenuType: "MG",
      MenuGroupCode: "",
      ModuleCode: "",
      selectedGroup: {
        label: this.state.SelectMainMenuGroup,
        value: this.state.SelectMainMenuGroup,
      },
      PageURL: "",
      DefaultExpanse: "0",
      ExtendedPerm: "",
      SubMenu: true,
    });
  }

  updateState(prop, value) {
    this.setState({ [prop]: value });
  }

  cancelHandle() {
    this.props.history.push({ pathname: FeatureList.routeName });
  }

  resetHandle() {
    this.setState({
      rowKey: "",
      MenuCode: "",
      MenuName: "",
      MenuType: "MG",
      MenuGroupCode: "",
      ModuleCode: "",
      PageURL: "",
      selectedGroup: "",
      DefaultExpanse: "0",
      ExtendedPerm: "",
    });
  }

  clearMessages() {
    this.setState({
      errors: [],
      successMessage: "",
    });
  }

  validate() {
    let errors = [];

    if (this.state.MenuCode.trim() === "") {
      errors.push("* Menu Code cannot be blank.");
    }
    if (this.state.MenuName.trim() === "") {
      errors.push("* Menu Name cannot be blank.");
    }
    if (this.state.ModuleCode.trim() === "") {
      errors.push("* Module Code cannot be blank.");
    }

    if (this.state.PageURL.length === 0) {
      errors.push("* PageURL cannot be blank.");
    }
    // if (this.state.DefaultExpanse != 0 || this.state.DefaultExpanse != 1) {
    //     errors.push("* Please add boolean value (0 or 1)");
    // }
    if (errors.length > 0) {
      this.setState({
        errors,
        messageVisible: true,
        successMessage: "",
      });
      return false;
    } else return true;
  }

  async submitHandle() {
    this.setState({ isLoading: true });
    this.clearMessages();
    if (this.validate() === false) return;
    else {
      //if it main menu => MenuGroupCode = MenuCode
      //not => MenuGroupCode = SelectedGroupCode
      if (this.state.formState === "edit" && this.state.MenuType === "MG") {
        //Update Main Feature's Group is changed automatically change Sub Feature's Group
        this.state.SelectedSubMenu.map(async (data) => {
          await UpdateMenuGroup(this.state.MenuCode, data);
        });
      }

      var res = await saveFeature(this.state);
      if (res === 401) {
        this.setState({ isExpired: true });
      } else if (res.status) {
        this.setState(
          {
            errors: [],
            successMessage: "Feature has been saved successful.",
            messageVisible: true,
            roleFeatureId: "",
          },
          () => this.resetHandle()
        );

        if (this.state.formState === "edit")
          this.props.history.push({ pathname: FeatureList.routeName });
      } else {
        this.setState({
          errors: [res.message],
          messageVisible: true,
          successMessage: "",
        });
      }

      this.setState({ isLoading: false });
    }
  }

  render() {
    const { data } = this.state;
    return (
      <Container fluid className="main-content-container px-4">
        <Row noGutters className="page-header py-4">
          {this.state.formState === "new" ? (
            <PageTitle sm="4" title="New Feature" className="text-sm-left" />
          ) : (
            <PageTitle sm="4" title="Edit Feature" className="text-sm-left" />
          )}
        </Row>
        <Row>
          <Col xs="12" lg="6">
            <Card>
              <CardBody>
                <Form>
                  <Row xs="12" lg="12">
                    <Col xs="12" lg="12">
                      {this.state.CreateSubMenuMode === true ? (
                        <FormGroup row>
                          <Label htmlFor="MainMenuName" sm={4}>
                            Main Menu Name
                          </Label>
                          <Col sm={8}>
                            <Input
                              disabled={true}
                              id="MainMenuName"
                              type="text"
                              value={this.state.SelectMainMenuName}
                            />
                          </Col>
                        </FormGroup>
                      ) : (
                        ""
                      )}
                      {/* /////////////////////////////// MenuCode*/}
                      <FormGroup row>
                        <Label htmlFor="MenuCode" sm={4}>
                          Menu Code <span style={{ color: "red" }}> * </span>
                        </Label>
                        <Col sm={8}>
                          <Input
                            maxLength={30}
                            id="MenuCode"
                            placeholder="Menu Code"
                            type="text"
                            value={this.state.MenuCode}
                            onChange={(evt) =>
                              this.updateState("MenuCode", evt.target.value)
                            }
                          />
                        </Col>
                      </FormGroup>
                      {/* /////////////////////////////// Menu Name*/}
                      <FormGroup row>
                        <Label htmlFor="MenuName" sm={4}>
                          Menu Name <span style={{ color: "red" }}> * </span>
                        </Label>
                        <Col sm={8}>
                          <Input
                            maxLength={30}
                            id="MenuName"
                            placeholder="Menu Name"
                            type="text"
                            value={this.state.MenuName}
                            onChange={(evt) =>
                              this.updateState("MenuName", evt.target.value)
                            }
                          />
                        </Col>
                      </FormGroup>
                      {/* ///////////////////////////// Menu Type*/}
                      &nbsp;
                      {this.state.formState === "new" ? (
                        <FormGroup row tag="fieldset">
                          <Label htmlFor="Menutype" sm={4}>
                            Menu type
                          </Label>
                          <Col sm={8}>
                            <div>
                              <FormGroup check>
                                <Input
                                  value={"MG"}
                                  name="radio1"
                                  type="radio"
                                  checked={this.state.MenuType === "MG"}
                                  onChange={() =>
                                    this.setState({ MenuType: "MG" })
                                  }
                                />{" "}
                                <Label check>Main Route (MG)</Label>
                              </FormGroup>
                            </div>
                            &nbsp;
                            <div>
                              <FormGroup check>
                                <Input
                                  value={"ME"}
                                  checked={this.state.MenuType === "ME"}
                                  onChange={() =>
                                    this.setState({ MenuType: "ME" })
                                  }
                                  name="radio2"
                                  type="radio"
                                />{" "}
                                <Label check>Sub Route (ME)</Label>
                              </FormGroup>
                            </div>
                          </Col>
                        </FormGroup>
                      ) : (
                        <FormGroup row tag="fieldset">
                          <Label htmlFor="Menutype" sm={4}>
                            Menu type
                          </Label>
                          <Col sm={8}>
                            <div>
                              <FormGroup check>
                                <Input
                                  disabled={
                                    this.state.MenuType === "MG" ? false : true
                                  }
                                  value={"MG"}
                                  name="radio1"
                                  type="radio"
                                  checked={this.state.MenuType === "MG"}
                                  onChange={() =>
                                    this.setState({ MenuType: "MG" })
                                  }
                                />{" "}
                                <Label check>Main Route (MG)</Label>
                              </FormGroup>
                            </div>
                            &nbsp;
                            <div>
                              <FormGroup check>
                                <Input
                                  value={"ME"}
                                  checked={this.state.MenuType === "ME"}
                                  onChange={() =>
                                    this.setState(
                                      { MenuType: "ME" },
                                      this.CreateME()
                                    )
                                  }
                                  name="radio2"
                                  type="radio"
                                />{" "}
                                <Label check>Sub Route (ME)</Label>
                              </FormGroup>
                            </div>
                          </Col>
                        </FormGroup>
                      )}
                      &nbsp;
                      {/* /////////////////////////////// Group*/}
                      {this.state.MenuType === "ME" ? (
                        <FormGroup row xs={12}>
                          <Label xs={4} htmlFor="Menu Group">
                            Menu Group
                          </Label>
                          <br />
                          <Col xs={8}>
                            <Select
                              options={this.state.group}
                              isDisabled={this.state.SubMenu}
                              value={this.state.selectedGroup}
                              defaultValue={this.state.selectedGroup}
                              onChange={(value) =>
                                this.updateState("selectedGroup", value)
                              }
                            />
                          </Col>
                        </FormGroup>
                      ) : (
                        ""
                      )}
                      {/* Copy */}
                      {/* /////////////////////////////// Module Code*/}
                      <FormGroup row>
                        <Label htmlFor="ModuleCode" sm={4}>
                          Module Code <span style={{ color: "red" }}> * </span>
                        </Label>
                        <Col sm={8}>
                          <Input
                            maxLength={30}
                            id="ModuleCode"
                            placeholder="Module Code"
                            type="text"
                            value={this.state.ModuleCode}
                            onChange={(evt) =>
                              this.updateState("ModuleCode", evt.target.value)
                            }
                          />
                        </Col>
                      </FormGroup>
                      {/* /////////////////////////////// Page URL*/}
                      <FormGroup row>
                        <Label htmlFor="PageURL" sm={4}>
                          PageURL <span style={{ color: "red" }}> * </span>
                        </Label>
                        <Col sm={8}>
                          <Input
                            id="PageURL"
                            placeholder="PageURL"
                            type="text"
                            value={this.state.PageURL}
                            onChange={(evt) =>
                              this.updateState("PageURL", evt.target.value)
                            }
                          />
                        </Col>
                      </FormGroup>
                      {/* /////////////////////////////// Default Expanse*/}
                      <FormGroup row>
                        <Label htmlFor="DefaultExpanse" sm={4}>
                          Default Expanse
                        </Label>
                        <Col sm={8}>
                          <Input
                            id="DefaultExpanse"
                            type="text"
                            value={this.state.DefaultExpanse}
                            onChange={(evt) =>
                              this.updateState(
                                "DefaultExpanse",
                                evt.target.value
                              )
                            }
                          />
                        </Col>
                      </FormGroup>
                      {/* //////////////////////////////                                                                                                                                                                                                                                                                                                                                                                                                / Extended Perm*/}
                      <FormGroup row>
                        <Label htmlFor="ExtendedPerm" sm={4}>
                          Extended Perm
                        </Label>
                        <Col sm={8}>
                          <Input
                            id="ExtendedPerm"
                            type="text"
                            value={this.state.ExtendedPerm}
                            onChange={(evt) =>
                              this.updateState("ExtendedPerm", evt.target.value)
                            }
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                  &nbsp;&nbsp;&nbsp;
                </Form>
                {/* Data saving is fail */}
                {this.state.errors.length > 0 && (
                  <Alert
                    color="danger"
                    isOpen={this.state.messageVisible}
                    toggle={() => this.setState({ messageVisible: false })}
                  >
                    {this.state.errors.map((msg, index) => (
                      <span key={index}>
                        {msg}
                        <br />
                      </span>
                    ))}
                  </Alert>
                )}
                {/* Data saving is Successful  */}
                {this.state.successMessage !== "" && (
                  <Alert
                    isOpen={this.state.messageVisible}
                    toggle={() => this.setState({ messageVisible: false })}
                  >
                    <span>
                      {this.state.successMessage}
                      <br />
                    </span>
                  </Alert>
                )}
              </CardBody>
              {this.state.formState === "new" ? (
                <CardFooter>
                  <Button
                    type="submit"
                    color="primary"
                    onClick={() => this.submitHandle()}
                  >
                    <i className="fa fa-save"></i> Save
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button
                    type="reset"
                    color="danger"
                    onClick={() => this.resetHandle()}
                  >
                    <i className="fa fa-ban"></i> Reset
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button
                    type="reset"
                    color="info"
                    onClick={() => this.cancelHandle()}
                  >
                    <i className="fa fa-list-alt"></i> Go To List
                  </Button>
                </CardFooter>
              ) : (
                ""
              )}
              {this.state.formState === "edit" ? (
                <CardFooter>
                  <Button
                    type="submit"
                    size="sm"
                    color="primary"
                    onClick={() => this.submitHandle()}
                  >
                    <i className="fa fa-save"></i> Save
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button
                    type="reset"
                    size="sm"
                    color="danger"
                    onClick={() => this.cancelHandle()}
                  >
                    <i className="fa fa-ban"></i> Cancel
                  </Button>
                </CardFooter>
              ) : (
                ""
              )}
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return { auth: state.auth };
}
export default connect(mapStateToProps)(FeatureEntry);
